<template>
    <div>
        <div class="dh_p1a w-100">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">About M3</span><br>
                    <span class="dh_p1c">ESG (Environmental, Social and Governance) as the core of corporate management,<br>pursuing customer value rather than price. With its own platform equipped with integrated BIM and DfMA core technology,<br>we implement buildings more conveniently and quickly.</span>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">
                <!-- CEO PROLOGUE -->
                <div class="py-5">
                    <div class="x_div_left py-3">
                        <h2 class="fen-set3 fs-16" style="display: flex; align-items: center; gap: 10px;">
                            <span style="display: flex; flex-direction: column;">
                                <span style="width: 8px; height: 12px; background-color: #999; display: block;"></span>
                                <span style="width: 8px; height: 12px; background-color: #333; display: block;"></span>
                            </span>
                            <strong>CEO PROLOGUE</strong>
                        </h2>
                    </div>
                    <div v-if="!isMobileDevice" class="iw-1 py-2 d-flex"
                        style="align-items: center; gap: 40px; position: relative;">
                        <div class="iw-2 px-3" style="line-height: 175%; position: relative; z-index: 2;">
                            <p class="fkr-set2 fs-17" style="color: #7F1B27; line-height: 130%;"><strong>Hello.<br>This is M3 Systems.</strong></p>
                            <p class="fkr-set2 fs-11 py-2">I have served as a professor of architecture in Korea since 1996.<br>I founded various academic societies and associations, introduced BIM, the digital twin technology in the construction field, to Korea,<br>and have long made the integration of AI and BIM my life's work.</p>
                            <p class="fkr-set2 fs-11 py-2">I believe the construction industry, an old industry, must become manufactured, automated, and advanced through digital transformation.<br>Chronic problems such as construction delays, poor construction, and cost increases are now compounded by issues like labor shortages,<br>safety accidents, and carbon emissions, demanding disruptive innovation.
                            </p>
                            <p class="fkr-set2 fs-11 py-2">The time is ripe. I intend to fully unfold the knowledge and experience<br>accumulated over decades.<br>A 'DfMA-based specialized manufactured construction platform' where both consumers and producers transparently participate in a digital environment<br>throughout the entire process of design, manufacturing, construction, and maintenance so that anyone can build quickly, easily,<br>and satisfactorily will be the construction business model leading the future.</p>
                            <p class="fkr-set2 fs-11 py-2">High-quality modular buildings, seamlessly designed, safely manufactured in factories, moved to sites, and installed in an instant,<br>will appear one after another around us.<br>A future that will be completely transformed is opening up before our eyes.<br>As a leader in future technology, M3 Systems will continue to grow.</p>
                            <div class="py-4"
                                style="display: flex; align-items: center; justify-content: right; gap: 15px; margin-right: -150px;">
                                <span class="fkr-set1 fs-13">CEO</span>
                                <span class="fkr-set1 fs-20"><strong>Inhan Kim</strong></span>
                                <img src="@/assets/img/m3_introduce/ik_sign.png" width="150" style="margin-left: 10px;">
                            </div>
                        </div>
                        <div style="flex-shrink: 0; width: 40%; position: relative; z-index: 1;">
                            <img src="@/assets/img/m3_introduce/ik_profile.png" width="100%"
                                style="border-radius: 8px; object-fit: cover;">
                        </div>
                    </div>
                    <div v-else class="py-2">
                        <div class="px-3" style="line-height: 175%;">
                            <p class="fkr-set2 fs-17" style="color: #7F1B27; line-height: 130%;"><strong>Hello.<br>This is M3 Systems.</strong></p>
                            <p class="fkr-set2 fs-11 py-2">I have served as a professor of architecture in Korea since 1996. I founded various academic societies and associations, introduced BIM, the digital twin technology in the construction field, to Korea, and have long made the integration of AI and BIM my life's work.</p>
                            <p class="fkr-set2 fs-11 py-2">I believe the construction industry, an old industry, must become manufactured, automated, and advanced through digital transformation. Chronic problems such as construction delays, poor construction, and cost increases are now compounded by issues like labor shortages, safety accidents, and carbon emissions, demanding disruptive innovation.
                            </p>
                            <p class="fkr-set2 fs-11 py-2">The time is ripe. I intend to fully unfold the knowledge and experience accumulated over decades. A 'DfMA-based specialized manufactured construction platform' where both consumers and producers transparently participate in a digital environment throughout the entire process of design, manufacturing, construction, and maintenance so that anyone can build quickly, easily, and satisfactorily will be the construction business model leading the future.</p>
                            <p class="fkr-set2 fs-11 py-2">High-quality modular buildings, seamlessly designed, safely manufactured in factories, moved to sites, and installed in an instant, will appear one after another around us. A future that will be completely transformed is opening up before our eyes. As a leader in future technology, M3 Systems will continue to grow.</p>
                            <div class="text-center py-3"
                                style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                                <span class="fkr-set1 fs-11">CEO</span>
                                <span class="fkr-set1 fs-16"><strong>Inhan Kim</strong></span>
                                <img src="@/assets/img/m3_introduce/ik_sign.png" width="100" style="margin-left: 5px;">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- (주)엠쓰리시스템즈 -->
                <div class="py-5">
                    <div class="iw-1"
                        :class="{ 'd-flex': !isMobileDevice }"
                        style="border-bottom: 2px solid #7F1B27; border-top: 2px solid #7F1B27;"
                        :style="!isMobileDevice ? 'align-items: center; gap: 40px;' : ''">
                        <div :class="isMobileDevice ? 'text-center py-3' : 'iw-2 px-3'">
                            <img src="@/assets/img/s_info/s_info_logo.png" 
                                :style="isMobileDevice ? 'max-width: 250px; width: 100%;' : 'max-width: 400px; width: 100%;'">
                        </div>
                        <div :class="isMobileDevice ? 'px-3 pb-3' : 'iw-2 px-3'" style="line-height:200%">
                            <div v-if="!isMobileDevice" style="height:20px"></div>
                            <p class="fkr-set2 fs-13 fc-w10"><strong>M3systems Co., Ltd.</strong></p>
                            <p class="fkr-set2 fs-09"><strong>Manufactured Modular via Meta-X Systems.</strong></p>
                            <p class="fkr-set2 fs-09">M3 is a modular architecture integrated platform service company with advanced BIM integrated DfMA technology.</p>
                            <p class="fkr-set2 fs-09">Based on ESG (Environmental, Social and Governance) corporate management ethics, we provide fast, accurate, and convenient architectural spaces with professionals.</p>
                            <p class="fkr-set2 fs-09">With the researchers' experience and expertise in BIM R&D over the past 20 years, we will grow into a reliable company that makes premium modular buildings.</p>
                            <div v-if="!isMobileDevice" style="height:20px"></div>
                        </div>
                    </div>
                </div>
                <!-- Characteristics 제거 - DeclanKim 2025.12.05.sprint2 -->
                <!-- <div class="py-3">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong>
                                <h2>Characteristics</h2>
                            </strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">The M3 leads with speed, quality, technology, and eco-friendly architecture.</span>
                    </div>
                    <div class="iw-1">
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info2.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Speed</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">Optimized design that meets customer preferences and requirements and realize it quickly.</div>
                                </div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info3.png" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Higher Quality</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">Through digitization and manufacturing, we provide price, value, and high-quality buildings quickly.</div>
                                </div>
                            </div>
                        </div>
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info4.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>BIM + Platform</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">We provide fast and high-quality architectural services with accumulated BIM technology and DfMA platform.
                                    </div>
                                </div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info5.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Eco-Friendly</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">Modular construction reduces waste materials and the eco-friendly design effectively reduces cooling and heating costs.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height:50px"></div> -->

                <div class="py-3" style="border-bottom:1px solid #e9e9e9; overflow-x:auto">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong>
                                <h2>Facilities</h2>
                            </strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">A place to create your dreams and future.</span></div>
                    <div class="iw-1">
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s1"><img
                                    src="@/assets/img/s_info/s_info_m1_ver251209.jpg" width="100%" height="250">
                                <div class="x_div_center py-2 fkr-set1 fs-10">Giheung Office</div>
                            </div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s2"><img
                                    src="@/assets/img/s_info/s_info_m2_ver251209.jpg" width="100%" height="250">
                                <div class="x_div_center py-2 fkr-set1 fs-10">Seoul Office</div>
                            </div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s3"><img
                                    src="@/assets/img/s_info/s_info_m3_ver251209.jpg" width="100%" height="250">
                                <div class="x_div_center py-2 fkr-set1 fs-10">Icheon Factory</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 본사 -->
                <div id="v-s1" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Giheung Office</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m1_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 부설연구소 -->
                <div id="v-s2" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Seoul Office</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m2_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 모듈러 공장 -->
                <div id="v-s3" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Icheon Factory</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m3_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- <MenuFooter /> -->
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooterEn.vue'
export default {
    name: 'MenuIntroduction',
    components: {
        MenuFooter
    },
    computed: {
        isMobileDevice() {
            return window.innerWidth <= 1024
        }
    }
}
</script>